module.exports = __webpack_public_path__ + "static/img/5.bef4ea3f.png";